import { Component } from '@angular/core';

@Component({
  selector: 'app-mes-cartes-tiers-payant',
  templateUrl: './mes-cartes-tiers-payant.component.html',
  styleUrls: ['./mes-cartes-tiers-payant.component.scss']
})
export class MesCartesTiersPayantComponent {
constructor(){}

}
